import { FormControl, MenuItem, OutlinedInput, Select } from "@mui/material";
import zeroDeductibleUniform from "../utils/zeroDeductibleUniform";
import { LEAVE_BLANK } from "./auto_quotation/leaveBlank";

const LEAVE_BLANK_COLOR = '#f44336';

export default function CustomSelect2({ items, sx, style, value, onChange, disabled = false, readOnly = false, isZeroDeductibleUniform = true, error = false, dense = false }) {


  return (
    <FormControl sx={sx} error={error}>
      <Select
        size="small"
        value={value}
        onChange={onChange}
        sx={{
          ...(dense ? { fontSize: 12, height: 32, '& .MuiSelect-select': { display: 'flex', alignItems: 'center', py: 0 } } : { fontSize: 14 }),
          ...(value === LEAVE_BLANK && { color: LEAVE_BLANK_COLOR }),
        }}
        MenuProps={dense ? { PaperProps: { sx: { '& .MuiMenuItem-root': { fontSize: 12, minHeight: 'auto' } } } } : undefined}
        input={<OutlinedInput />}
        // renderValue={(selected) => {
        //   if (selected == undefined || selected.length === 0) {
        //     return <em>Select</em>;
        //   }

        //   return selected;
        // }}
        displayEmpty
        style={style}
        disabled={disabled}
        readOnly={readOnly}
      >
        <MenuItem disabled value="">
          <em>Select</em>
        </MenuItem>
        {items && items.map((item, index) => (
          <MenuItem key={index} value={item} sx={item === LEAVE_BLANK ? { color: LEAVE_BLANK_COLOR } : undefined}>
            {
              isZeroDeductibleUniform ? zeroDeductibleUniform(item) : item
            }
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}